import React from "react"
import { Form, Row, Col } from "react-bootstrap"
import FormLabel from "./formLabel"
import { Field } from "formik"

function FormDisabledTextBox(props) {
  const { textDesc, field, toUpperCase } = props

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} />
        <Col xs={12} md={6} className="marginTop10px">
          <Field
            name={field.name}
            className="inputbox"
            type="text"
            autoComplete="new-password"
            value={
              toUpperCase
                ? field.value.toUpperCase()
                : field.value
                ? field.value
                : ""
            }
            readOnly="readOnly"
          />
        </Col>
      </Row>
    </Form.Group>
  )
}
export default FormDisabledTextBox
